import tilePonteNaviglioGrande01 from "assets/hard/PONTE-NAVIGLIO-GRANDE/01.jpg";
import tilePonteNaviglioGrande02 from "assets/hard/PONTE-NAVIGLIO-GRANDE/02.jpg";
import tilePonteNaviglioGrande03 from "assets/hard/PONTE-NAVIGLIO-GRANDE/03.jpg";
import tilePonteNaviglioGrande04 from "assets/hard/PONTE-NAVIGLIO-GRANDE/04.jpg";
import tilePonteNaviglioGrande05 from "assets/hard/PONTE-NAVIGLIO-GRANDE/05.jpg";
import tilePonteNaviglioGrande06 from "assets/hard/PONTE-NAVIGLIO-GRANDE/06.jpg";
import tilePonteNaviglioGrande07 from "assets/hard/PONTE-NAVIGLIO-GRANDE/07.jpg";
import tilePonteNaviglioGrande08 from "assets/hard/PONTE-NAVIGLIO-GRANDE/08.jpg";
import tilePonteNaviglioGrande09 from "assets/hard/PONTE-NAVIGLIO-GRANDE/09.jpg";
import tilePonteNaviglioGrande10 from "assets/hard/PONTE-NAVIGLIO-GRANDE/10.jpg";
import tilePonteNaviglioGrande11 from "assets/hard/PONTE-NAVIGLIO-GRANDE/11.jpg";
import tilePonteNaviglioGrande12 from "assets/hard/PONTE-NAVIGLIO-GRANDE/12.jpg";
import tilePonteNaviglioGrande13 from "assets/hard/PONTE-NAVIGLIO-GRANDE/13.jpg";
import tilePonteNaviglioGrande14 from "assets/hard/PONTE-NAVIGLIO-GRANDE/14.jpg";
import tilePonteNaviglioGrande15 from "assets/hard/PONTE-NAVIGLIO-GRANDE/15.jpg";
import tilePonteNaviglioGrande16 from "assets/hard/PONTE-NAVIGLIO-GRANDE/16.jpg";
import tilePonteNaviglioGrande17 from "assets/hard/PONTE-NAVIGLIO-GRANDE/17.jpg";
import tilePonteNaviglioGrande18 from "assets/hard/PONTE-NAVIGLIO-GRANDE/18.jpg";
import tilePonteNaviglioGrande19 from "assets/hard/PONTE-NAVIGLIO-GRANDE/19.jpg";
import tilePonteNaviglioGrande20 from "assets/hard/PONTE-NAVIGLIO-GRANDE/20.jpg";
import tilePonteNaviglioGrande21 from "assets/hard/PONTE-NAVIGLIO-GRANDE/21.jpg";
import tilePonteNaviglioGrande22 from "assets/hard/PONTE-NAVIGLIO-GRANDE/22.jpg";
import tilePonteNaviglioGrande23 from "assets/hard/PONTE-NAVIGLIO-GRANDE/23.jpg";
import tilePonteNaviglioGrande24 from "assets/hard/PONTE-NAVIGLIO-GRANDE/24.jpg";
import tilePonteNaviglioGrande25 from "assets/hard/PONTE-NAVIGLIO-GRANDE/25.jpg";
import tilePonteNaviglioGrande26 from "assets/hard/PONTE-NAVIGLIO-GRANDE/26.jpg";
import tilePonteNaviglioGrande27 from "assets/hard/PONTE-NAVIGLIO-GRANDE/27.jpg";
import tilePonteNaviglioGrande28 from "assets/hard/PONTE-NAVIGLIO-GRANDE/28.png";
import tilePonteNaviglioGrande29 from "assets/hard/PONTE-NAVIGLIO-GRANDE/29.png";
import tilePonteNaviglioGrande30 from "assets/hard/PONTE-NAVIGLIO-GRANDE/30.jpg";
import tilePonteNaviglioGrande31 from "assets/hard/PONTE-NAVIGLIO-GRANDE/31.jpg";
import tilePonteNaviglioGrande32 from "assets/hard/PONTE-NAVIGLIO-GRANDE/32.jpg";
import tilePonteNaviglioGrande33 from "assets/hard/PONTE-NAVIGLIO-GRANDE/33.jpg";
import tilePonteNaviglioGrande34 from "assets/hard/PONTE-NAVIGLIO-GRANDE/34.jpg";
import tilePonteNaviglioGrande35 from "assets/hard/PONTE-NAVIGLIO-GRANDE/35.jpg";
import tilePonteNaviglioGrande36 from "assets/hard/PONTE-NAVIGLIO-GRANDE/36.jpg";
import fullImage from "assets/hard/PONTE-NAVIGLIO-GRANDE/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const ponteNaviglioGrande: ILevel = {
  difficulty: LevelDifficulties.hard,
  type: LevelTypes.bridge,
  name: "Naviglio Grande",
  fullImage,
  successDialogContent: {
    subtitle: "Hai completato il PONTE SUL NAVIGLIO GRANDE",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/ingegneria-e-digitalizzazione/le-grandi-opere-civili.html`,
    contents: [
      {
        text: "Un’opera elegante e armonica",
        isBold: true,
      },
      {
        text:
          ", integrata perfettamente nel contesto naturale circostante. Il ",
        isBold: false,
      },
      {
        text: "ponte sul Naviglio Grande",
        isBold: true,
      },
      {
        text:
          " contribuisce a rendere più efficienti e rapidi i trasporti sulla linea Torino-Milano. È costituito da due archi in acciaio con sezione aperta a doppia T, per una larghezza complessiva di 14,92 metri. Una ",
        isBold: false,
      },
      {
        text: "soluzione innovativa",
        isBold: true,
      },
      {
        text:
          " non solo dal punto di vista ingegneristico, ma anche architettonico. Infatti il disegno riprende quello dei ",
        isBold: false,
      },
      {
        text: "classici ponti ad arco",
        isBold: true,
      },
      {
        text: ", utilizzati dalle ferrovie fin dalle prime realizzazioni.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tilePonteNaviglioGrande01,
    tilePonteNaviglioGrande02,
    tilePonteNaviglioGrande03,
    tilePonteNaviglioGrande04,
    tilePonteNaviglioGrande05,
    tilePonteNaviglioGrande06,
    tilePonteNaviglioGrande07,
    tilePonteNaviglioGrande08,
    tilePonteNaviglioGrande09,
    tilePonteNaviglioGrande10,
    tilePonteNaviglioGrande11,
    tilePonteNaviglioGrande12,
    tilePonteNaviglioGrande13,
    tilePonteNaviglioGrande14,
    tilePonteNaviglioGrande15,
    tilePonteNaviglioGrande16,
    tilePonteNaviglioGrande17,
    tilePonteNaviglioGrande18,
    tilePonteNaviglioGrande19,
    tilePonteNaviglioGrande20,
    tilePonteNaviglioGrande21,
    tilePonteNaviglioGrande22,
    tilePonteNaviglioGrande23,
    tilePonteNaviglioGrande24,
    tilePonteNaviglioGrande25,
    tilePonteNaviglioGrande26,
    tilePonteNaviglioGrande27,
    tilePonteNaviglioGrande28,
    tilePonteNaviglioGrande29,
    tilePonteNaviglioGrande30,
    tilePonteNaviglioGrande31,
    tilePonteNaviglioGrande32,
    tilePonteNaviglioGrande33,
    tilePonteNaviglioGrande34,
    tilePonteNaviglioGrande35,
    tilePonteNaviglioGrande36,
  ],
};
